export default __webpack_public_path__ + "static/media/ENDROLL1.STR[0].88ef358d.mp4";